import React from "react";
import { cn } from "utils";
import { OspIcons } from "@ospweb/sdk-ui/src/Icon/OspIcons";

export interface RightContentProps {
  /** 百分比值 */
  percent: string;
  /** 是否为上涨趋势 */
  isPositive?: boolean;
  /** 是否显示图标 */
  showIcon?: boolean;
  /** 自定义类名 */
  className?: string;
}

/**
 * 右侧百分比显示组件
 * 统一的百分比显示样式，包含图标和百分比文本
 */
export const RightContent: React.FC<RightContentProps> = ({
  percent,
  isPositive = true,
  showIcon = true,
  className,
}) => {
  return (
    <div
      className={cn("flex gap-0.5 items-center rounded-30 shrink-0", className)}
    >
      {showIcon && (
        <OspIcons
          name="upvote"
          size={12}
          className={cn(
            isPositive
              ? "text-content_accent1_primary"
              : "text-content_accent2_primary rotate-180",
          )}
        />
      )}
      <p
        className={cn(
          "body_medium_s",
          isPositive
            ? "text-content_accent1_primary"
            : "text-content_accent2_primary",
        )}
      >
        {percent}
      </p>
    </div>
  );
};
